import infoBanner from './js/old/infoBanner';
import './scss/old-acf-blocks/infograph.scss';

document.addEventListener( 'DOMContentLoaded', () => {

	infoBanner();

} );
